import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
//引入饿了么样式
import './plugins/element.js';
import './tools/rem.js';
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
